import CardCommon, { CardCommonType } from '@op/components/CardCommon';
import React, { useMemo, useRef } from 'react';
import './index.scss';

const IFrameCard = (props: { url: string } & CardCommonType) => {
  const { url, ...restProps } = props;
  const iframeRef = useRef(null);
  // useInitBuriedPointInfo({
  //   buriedPoint: ,
  //   triggerPagePoint: false,
  // });

  // 判断链接是否为图片
  const isImageUrl = useMemo(() => {
    const imageExtensions = /\.(jpg|jpeg|png|gif|bmp|svg)$/i;
    return imageExtensions.test(url);
  }, [url]);

  return (
    <CardCommon
      {...restProps}
      className={`dbo-iframe-card ${isImageUrl ? 'img-box' : ''}`}
    >
      {isImageUrl ? (
        <img src={url} className="iframe-img"></img>
      ) : (
        <iframe src={url} className="iframe-info" ref={iframeRef} />
      )}
    </CardCommon>
  );
};

export default IFrameCard;
